import { ca } from '@cian/analytics';
import { EDealType } from '../../types/dealType';

export const trackDealTypeTabsClick = (dealType: EDealType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_tab',
    label: dealType,
  });
};
